// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import utils from './utils'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import '@/assets/css/element-ui.css'
import Vuetify from 'vuetify'
// import 'vuetify/dist/vuetify.min.css'
import '@/assets/css/vuetify.min.css'
import Print from 'vue-print-nb'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import MaterialDesignIcons from 'material-design-icons-iconfont'
// import htmlToPdf from '@/utils/htmlToPdf'

// Vue.use(htmlToPdf)
Vue.use(Vuetify)
Vue.use(ElementUI)
Vue.use(Print)
Vue.use(VueAwesomeSwiper)
Vue.use(MaterialDesignIcons)

Vue.config.productionTip = false

Vue.prototype.$u = utils

// aixos

export const http = axios.create({
  // timeout: 20000// request timeout
  timeout: 120000
})

// 增加请求拦截器
http.interceptors.request.use(function (config) {
  // deal token
  let token = utils.storage.get_token()
  if (token) {
    config.headers['Authorization'] = 'jwt ' + token
  }

  return config
}, function (error) {
  console.log('request error:', error)
  return Promise.reject(error)
})

// 增加一个response拦截器
http.interceptors.response.use(function (response) {
  return response
}, function (error) {
  let routeName = router.app._route.name
  let res = error.response
  if (res && res.status === 401) {
    if (routeName !== '') {
      router.push({ name: 'login', query: {next: routeName} })
    } else {
      router.push({ name: 'login' })
    }
  }

  return Promise.reject(error)
})

// 记录上一个路由地址
router.beforeEach((to, from, next) => {
  Vue.prototype.beforeRouter = from
  let permissionList = []
  // console.log('sssssssss', to.name)
  permissionList.push(router.options.routes[0].name)
  router.options.routes[0].children.forEach(res => {
    permissionList.push(res.name)
  })
  // console.log(permissionList)
  if (permissionList.indexOf(to.name) > 0) {
    if (localStorage.getItem('user_level') > utils.PERMISSION_VALUE.END_LEVEL) {
      next({name: 'feedback'})
    }
  }

  // console.log('ttttttt', router.options.routes[0].name)
  // console.log('tttttt', permission_list)
  next()
})

export let apiObj = (obj) => {
  let url = ''
  for (let key in obj) {
    if (url.indexOf('?') === -1) {
      url += '?' + key + '=' + obj[key]
    } else {
      url += '&' + key + '=' + obj[key]
    }
  }
  return url
}

Vue.prototype.$h = http

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js